import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { REMOVE_CREATED_SITE } from "../created-site.queries";
import {
  RemoveCreatedSiteMutation,
  RemoveCreatedSiteMutationVariables,
} from "../../../__generated__/RemoveCreatedSiteMutation";

export const useRemoveCreatedSite = () => {
  const [mutate, { loading }] = useMutation<
    RemoveCreatedSiteMutation,
    RemoveCreatedSiteMutationVariables
  >(REMOVE_CREATED_SITE, {
    refetchQueries: ["CustomerQuery", "CreatedSitesQuery"],
  });

  const removeCreatedSite = async (id: number): Promise<boolean> => {
    if (loading) return false;
    try {
      const { data } = await mutate({ variables: { id } });
      if (data?.removeCreatedSite?.ok) {
        toast.success("Le site a été supprimé");
        return true;
      }
      toast.error(data?.removeCreatedSite?.error ?? "Une erreur est survenue");
      return false;
    } catch (error: any) {
      const isForbidden = error?.graphQLErrors?.some(
        (e: any) =>
          e?.extensions?.code === "FORBIDDEN" ||
          e?.message?.toLowerCase().includes("forbidden")
      );
      toast.error(
        isForbidden
          ? "Action réservée aux administrateurs"
          : error?.message ?? "Une erreur est survenue"
      );
      return false;
    }
  };

  return { removeCreatedSite, loading };
};
